export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/IT-40c2c7b04142d8817122633c6e250397.png";